import { _ } from "../../../core/polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import PercentageVariationEditorWidget from "./PercentageVariationEditorWidget.js";

/**
 * Render multiple percentage variation value editors.
 *
 * Each editor displays a variation progress bar.
 *
 * @param {object} [spec.items] - Items to be edited. Each item is a literal
 * object comforming to the spec of `PercentageVariationEditorWidget`.
 * @param {number} [spec.variationScale] - Variation scale used in all editors.
 */
export default class MultiplePercentageVariationEditorWidget extends Widget {
	constructor({ items = [], variationScale = 15 } = {}) {
		super(...arguments);

		this._items = items;
		this._variationScale = variationScale;
	}

	renderContentOn(html) {
		html.div(
			{ klass: "percentage-variation-list" },
			this._renderLegendOn.bind(this),
			this._renderItemsOn.bind(this),
		);
	}

	_renderLegendOn(html) {
		html.div(
			{ klass: "legend" },
			html.div({ klass: "input-legend" }, _("Growth")),
			html.div(
				{ klass: "scale-legend" },
				html.div(
					{ klass: "scale-item minus" },
					`-${this._variationScale}%`,
				),
				html.div({ klass: "scale-item zero" }, "0%"),
				html.div(
					{ klass: "scale-item plus" },
					`${this._variationScale}%`,
				),
			),
		);
	}

	_renderItemsOn(html) {
		html.render(
			this._items.map(
				(item) =>
					new PercentageVariationEditorWidget({
						...item,
						variationScale: this._variationScale,
					}),
			),
		);
	}
}
